<template>
  <Body class="hero is-bold">
    <div class="hero-body">
      <div class="container" style="max-width:500px;">
        <article class="message is-primary">
          <div class="message-header">
            <p>{{ $t('MessageLoginBody.signin') }}</p>
          </div>
          <div class="message-body" @keyup.enter="inputs.tel != null ? login(inputs) : ''" >
            <b-field horizontal :label="$t('MessageLoginBody.tel')" style="font-size:12px;" >
                <b-input v-model="inputs.tel"
                placeholder="電話番号をご入力ください。"
                type="tel"
                >
                </b-input>
            </b-field>
            <b-field>
              <button class="button is-primary" @click="login(inputs)" v-if="!disabled" :disabled="disabled">
                {{ $t('TopNav.signin') }}
              </button>
              <button class="button is-primary" v-if="disabled" :disabled="disabled">
                {{ $t('TopNav.signin') }}
              </button>
            </b-field>
          </div>
        </article>
      </div>
    </div>
  </Body>
</template>

<script>
import Body from '@/components/layouts/Body'
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'MessageLoginBody',
  componentName: 'MessageLoginBody',
  components: {
    Body,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    seeker: {
      type: String
    },
  },
  data () {
    return {
      inputs: {
        tel: ''
      }
    }
  },
  computed: {
    disabled () {
      return this.inputs.tel === ''
    },
    ...mapState('auth', ['error','isMessageView'])
  },
  watch: {
    isMessageView () {
        if(this.isMessageView){
          localStorage.setItem('isLogin',true)
          this.$router.push({
            name: 'MessagePage',
            params: {
              seeker_id: this.seeker
            },
          })
        }
    }
  },
  created () {
    this.$store.dispatch('auth/initializeMessageLogin')
    localStorage.removeItem('isLogin')
  },
  methods: {
    login (inputs) {
      this.$store.dispatch('auth/messageLogin',{ tel: this.inputs.tel , seeker_id: this.seeker})
        .then(() => {
            if (this.error) {
              this.errorBar(this.error)
            }
        })
    },
    errorBar (e) {
      this.$buefy.snackbar.open({
        message: this.$t('MessageLoginBody.error'),
        type: 'is-danger',
        position: 'is-top'
      })
    }
  }
}
</script>

<style scoped>
p {
  font-weight: bold;
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/MessageLoginBody.vue